module.exports = __webpack_public_path__ + "media/audio_B.aad0b489.mp3";